const pseudoComponents_ArabLight = [
  { name: "PC01", Tb: 70.0, MW: 71.0, Tc: 390.85, Pc: 45.00, omega: -0.030, SG: 0.535 },
  {
    name: "PC02",
    Tb: 91.6,
    MW: 88.2,
    Tc: 425.35,
    Pc: 44.21,
    omega: -0.008,
    SG: 0.546,
  },
  {
    name: "PC03",
    Tb: 113.0,
    MW: 105.4,
    Tc: 458.85,
    Pc: 43.41,
    omega: 0.013,
    SG: 0.556,
  },
  {
    name: "PC04",
    Tb: 130.5,
    MW: 119.4,
    Tc: 485.75,
    Pc: 42.62,
    omega: 0.030,
    SG: 0.565,
  },
  {
    name: "PC05",
    Tb: 147.2,
    MW: 132.7,
    Tc: 510.85,
    Pc: 41.83,
    omega: 0.047,
    SG: 0.574,
  },
  {
    name: "PC06",
    Tb: 163.2,
    MW: 145.5,
    Tc: 534.55,
    Pc: 41.03,
    omega: 0.063,
    SG: 0.582,
  },
  {
    name: "PC07",
    Tb: 179.7,
    MW: 158.8,
    Tc: 558.75,
    Pc: 40.24,
    omega: 0.080,
    SG: 0.590,
  },
  {
    name: "PC08",
    Tb: 197.4,
    MW: 172.9,
    Tc: 584.05,
    Pc: 39.45,
    omega: 0.097,
    SG: 0.599,
  },
  {
    name: "PC09",
    Tb: 200.0,
    MW: 175.0,
    Tc: 587.75,
    Pc: 38.66,
    omega: 0.100,
    SG: 0.600,
  },
  {
    name: "PC10",
    Tb: 215.5,
    MW: 187.4,
    Tc: 609.45,
    Pc: 37.86,
    omega: 0.115,
    SG: 0.608,
  },
  {
    name: "PC11",
    Tb: 232.5,
    MW: 201.0,
    Tc: 633.05,
    Pc: 37.07,
    omega: 0.133,
    SG: 0.616,
  },
  {
    name: "PC12",
    Tb: 249.2,
    MW: 214.3,
    Tc: 655.75,
    Pc: 36.28,
    omega: 0.149,
    SG: 0.625,
  },
  {
    name: "PC13",
    Tb: 265.9,
    MW: 227.6,
    Tc: 678.25,
    Pc: 35.48,
    omega: 0.166,
    SG: 0.634,
  },
  {
    name: "PC14",
    Tb: 282.6,
    MW: 240.9,
    Tc: 700.25,
    Pc: 34.69,
    omega: 0.183,
    SG: 0.643,
  },
  {
    name: "PC15",
    Tb: 299.3,
    MW: 254.2,
    Tc: 721.95,
    Pc: 33.90,
    omega: 0.199,
    SG: 0.652,
  },
  {
    name: "PC16",
    Tb: 316.0,
    MW: 267.5,
    Tc: 743.25,
    Pc: 33.10,
    omega: 0.216,
    SG: 0.661,
  },
  {
    name: "PC17",
    Tb: 332.7,
    MW: 280.8,
    Tc: 764.35,
    Pc: 32.31,
    omega: 0.233,
    SG: 0.670,
  },
  {
    name: "PC18",
    Tb: 349.4,
    MW: 294.1,
    Tc: 785.05,
    Pc: 31.52,
    omega: 0.249,
    SG: 0.679,
  },
  {
    name: "PC19",
    Tb: 366.1,
    MW: 307.4,
    Tc: 805.45,
    Pc: 30.72,
    omega: 0.266,
    SG: 0.688,
  },
  {
    name: "PC20",
    Tb: 382.8,
    MW: 320.7,
    Tc: 825.55,
    Pc: 29.93,
    omega: 0.283,
    SG: 0.697,
  },
  {
    name: "PC21",
    Tb: 399.5,
    MW: 334.0,
    Tc: 845.25,
    Pc: 29.14,
    omega: 0.299,
    SG: 0.706,
  },
  {
    name: "PC22",
    Tb: 416.2,
    MW: 347.3,
    Tc: 864.75,
    Pc: 28.34,
    omega: 0.316,
    SG: 0.715,
  },
  {
    name: "PC23",
    Tb: 432.9,
    MW: 360.6,
    Tc: 883.95,
    Pc: 27.55,
    omega: 0.333,
    SG: 0.724,
  },
  {
    name: "PC24",
    Tb: 449.6,
    MW: 373.9,
    Tc: 902.85,
    Pc: 26.76,
    omega: 0.350,
    SG: 0.733,
  },
  {
    name: "PC25",
    Tb: 466.3,
    MW: 387.2,
    Tc: 921.55,
    Pc: 25.97,
    omega: 0.366,
    SG: 0.742,
  },
  {
    name: "PC26",
    Tb: 483.0,
    MW: 400.5,
    Tc: 939.95,
    Pc: 25.17,
    omega: 0.383,
    SG: 0.751,
  },
  {
    name: "PC27",
    Tb: 499.7,
    MW: 413.8,
    Tc: 958.05,
    Pc: 24.38,
    omega: 0.400,
    SG: 0.760,
  },
  {
    name: "PC28",
    Tb: 516.4,
    MW: 427.1,
    Tc: 975.85,
    Pc: 23.59,
    omega: 0.416,
    SG: 0.769,
  },
  {
    name: "PC29",
    Tb: 533.1,
    MW: 440.4,
    Tc: 993.45,
    Pc: 22.79,
    omega: 0.433,
    SG: 0.778,
  },
  {
    name: "PC30",
    Tb: 549.8,
    MW: 453.7,
    Tc: 1010.85,
    Pc: 22.00,
    omega: 0.450,
    SG: 0.787,
  },
];

export default pseudoComponents_ArabLight;
